import { Injectable, signal } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class TopBannerService {

    private _state = signal<{ message: string; messageType: 'success' | 'info' | 'error' } | null>(null);
    readonly state = this._state.asReadonly();

    private timer?: ReturnType<typeof setTimeout>;
    private messageDuration = 5_000;

    show(message: string, messageType: 'success' | 'info' | 'error'): void {
        clearTimeout(this.timer);
        this._state.set({ message, messageType });
        this.timer = setTimeout(() => this._state.set(null), this.messageDuration);
    }

    success(msg: string) { this.show(msg, 'success'); }
    info(msg: string)    { this.show(msg, 'info');    }
    error(msg: string)   { this.show(msg, 'error');   }
}
